module.exports = __webpack_public_path__ + "static/media/dull_night.58e639a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dull_night.png
// module id = 967
// module chunks = 0